module.exports = __webpack_public_path__ + "static/media/black-layers-icon.5891a3fa.svg";